import URL from './url';

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
};

export const getEstados = async () => {
  try {
    const res = await URL.get(`/api/estados`);
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    console.log("Error en action Estados", err);
  }
}

export const getEstadosEEUU = async () => {
  try {
    const res = await URL.get(`/api/estados/eeuu`);
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    console.log("Error en action Estados", err);
  }
}